// Module
var code = `<div class="card">
    <div class="card-header d-flex justify-content-between align-items-center" ng-click="ctrl.isCollapsed = !ctrl.isCollapsed" style="cursor: pointer;">
		<span class="card-title h4">
			<i class="fas fa-fw" ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
			<i class="fas fa-bullhorn"></i>
			<span>&nbsp;Service Announcements</span>
		</span>
        <div ng-click="\$event.stopPropagation();" ui-sref="manager.service-announcement-new" style="margin: -5px;">
			<i class="fas fa-plus-circle fa-2x"></i>
		</div>
	</div>
    <div ng-show="!ctrl.isCollapsed">
		<div class="flex-media-library">
			<div ng-repeat="item in ctrl.ServiceAnnouncements | orderBy:'name' track by item.id" class="flex-media-item">
				<bulk-select class="header" title="{{item.name}}" media-title="item.name"
					on-toggle="ctrl.toggleBulk(item.id)"></bulk-select>
				<div class="content">
					<div class="controls">
						<div class="d-grid mb-2" ng-if="ctrl.scene">
							<button type="button" 
								ng-click="ctrl.addToScene(item.id)"
								class="btn btn-sm btn-outline-primary"
								ng-disabled="!ctrl.isSceneActive()">
								<i class="fas fa-plus-circle"></i>
								<span>&nbsp;Add to playlist</span>
							</button>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span>Headline:</span>
								<span>{{item.headline}}</span>
							</div>
							<button type="button" ui-sref="manager.service-announcement-edit({id:item.id})"
								class="btn btn-sm btn-outline-primary">
								<i class="fa fa-fw fa-pencil"></i>
							</button>
						</div>
						<media-labels service-announcement-id="item.id"></media-labels>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>`;
// Exports
export default code;